import React, { useState } from 'react';
import './index.scss';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
const isMobile = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

const FlvPlayer = () => {
  const [phoneOpen, setPhoneOpen] = useState(undefined);
  const [nav, setNav] = useState(0);
  const navigate = useNavigate();
  function updateTitle(newTitle) {
    document.title = newTitle;
  }
  updateTitle('爆品涩');

  const phoneClick = () => {
    const newphoneOpen = !phoneOpen;
    console.log(isMobile(), newphoneOpen);
    setPhoneOpen(newphoneOpen);
  };

  const handleAboutLinkClick = (e) => {
    e.preventDefault(); // 阻止默认的链接跳转行为
    const aboutElement = document.getElementById('about');
    if (aboutElement) {
      aboutElement.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'start' // 滚动到元素顶部
      });
    }
  };

  return (
    <>
      <div className='baopinse'>
        <header className={`${isMobile() ? 'zhiboFLV ' : 'zhiboFLV'}${phoneOpen ? ' open' : ''}`}>
          <div className={`${isMobile() ? 'navCon-mobile' : 'navCon'}${phoneOpen ? ' open' : ''}`}>
            <div className='navLog'>
              <img className='navLog01' src={require('./assets/img/logoicon.png')}  alt="爆品涩 logo"/>
              <span>电商行业领先者</span>
            </div>
            {isMobile() && (
              <div className='header3-mobile-menu' onClick={() => {
                phoneClick();
              }}>
                <em />
                <em />
                <em />
              </div>
            )}
            {isMobile() ? (
              <div
                style={{
                  transform: phoneOpen ? 'translateX(0)' : '',
                  height: phoneOpen ? 'auto' : ''
                }}
                className='navDaoHang'
              >
                <ul>
                  <li className={`${nav === 0 ? 'clickThis' : ''}`} onClick={() => { setNav(0); }}>
                    <div className='diva'>
                      <span>首页</span><i /></div>
                  </li>
                  <li className={`${nav === 1 ? 'clickThis' : ''}`}    onClick={(e) => { setNav(1);
                        handleAboutLinkClick(e)
                 }}>
                    <div className='diva'>
                      <span>关于我们</span><i /></div>
                  </li>
                </ul>
              </div>
            ) : (
              <div className='navDaoHang'>
                <ul>
                  <li className={`${nav === 0 ? 'clickThis' : ''}`} onClick={() => { setNav(0); }}>
                    <div className='diva'>
                      <span>首页</span><i /></div>
                  </li>
                  <li className={`${nav === 1 ? 'clickThis' : ''}`} onClick={(e) => { setNav(1);
                        handleAboutLinkClick(e)
                 }}>
                    <div className='diva'>
                      <span>关于我们</span><i /></div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </header>
        <div className={isMobile() ? 'bannerCon bannerCon-Mobile' : 'bannerCon'}>
          {isMobile() ? (
            <div className='bannerText'>
              <p className='text28'>每日爆品，福利多多</p>
              <p className='text14'>专注为每一位奋斗者和消费者服务</p>
            </div>
          ) : null}
          <div className='xiazai'>免费下载 <RightOutlined /></div>
          <div className='banner0-icon'>
            <DownOutlined />
          </div>
        </div>
        <div className={isMobile() ? 'content01 content01-mobile' : 'content01'} id='about'>
          <div className='contentCon'>
            <div className='aboutdiv'>
              <div className='aboutLeft'>
                <h2>关于我们</h2>
                <p>爆品涩是一家集合全网购物商城、生活服务的电商导购平台，一站式接入淘宝、京东、拼多多、唯品会等全网购物平台，涵盖美食、出行、外卖、加油、娱乐等吃喝玩了生活服务平台，为消费者打造优惠、优选、全面的一站式线上消费商城，致力于成为用户“线上消费第一站</p>
                <i />
              </div>
              <div className='aboutRight'>
                <img className='navLog01' src={require('./assets/img/about.png')} alt='pic'/>
              </div>
            </div>
          </div>
        </div>
        <div className={isMobile() ? 'content02 content02-mobile' : 'content02'}>
          <div className='contentCon'>
            <img className='pic02' src={require('./assets/img/pic02.png')} alt='pic'/>
          </div>
        </div>
        <div className={isMobile() ? 'content03 content03-mobile' : 'content03'}>
          <div className='contentCon'>
            <div className='allIndustry'>
              <div className='title'>
                <span className='bigText'>全行业尽数</span><span className='smallText'>合作伙伴，覆盖消费全场景流量</span>
              </div>
              <div className='centerPic'>
                <img className='pic' src={require('./assets/img/pic03.png')} alt='淘宝'/>
                <img className='pic' src={require('./assets/img/pic04.png')} alt='京东'/>
                <img className='pic' src={require('./assets/img/pic06.png')} alt='拼多多'/>
                <img className='pic' src={require('./assets/img/pic12.png')} alt='抖音'/>
                <img className='pic' src={require('./assets/img/icon-kuaishou.png')} alt='快手'/>
              </div>
              <div className='centerPic'>
                <img className='pic' src={require('./assets/img/pic07.png')} alt='唯品会'/>
                <img className='pic' src={require('./assets/img/pic08.png')} alt='饿了么'/>
                <img className='pic' src={require('./assets/img/pic09.png')} alt='美团'/>
                <img className='pic' src={require('./assets/img/pic11.png')} alt='滴滴'/>
                <img className='pic' src={require('./assets/img/icon-dingdong.png')} alt='叮咚买菜'/>
              </div>
              <p className='more'><div className='morea'>更多精彩内容详见爆品涩APP</div></p>
            </div>
          </div>
        </div>
        <div className={isMobile() ? 'content04 content04-mobile' : 'content04'}>
          <div className='contentCon'>
            <div className='downLoadDiv'>
              <h2>立即开启您的省钱之旅</h2>
              <div className='xiazai2'>免费下载<RightOutlined /></div>
            </div>
          </div>
        </div>
        <div className={isMobile() ? 'footer footer-mobile' : 'footer'}>
          <div className='footerCon01'>
            <div className='footerLeftDiv'>
              <div className='footerLeft'>
                <div className='footerdiv'>
                  <span className='footerTitle'>商户合作</span>
                  <span className='footerText'>邮箱：kkyu@chargingsoup.com</span>
                </div>
                <div className='footerdiv'>
                  <span className='footerTitle'>客服投诉</span>
                  <span className='footerText'>邮箱：estellejin@chargingsoup.com</span>
                </div>
              </div>
              <div className='footerLeft'>
                <div className='footerdiv'>
                  <span className='footerTitle'>商家合作</span>
                  <span className='footerText'>邮箱：kkyu@chargingsoup.com</span>
                </div>
                <div className='footerdiv'>
                  <span className='footerTitle'>加入我们</span>
                  <span className='footerText'>邮箱：estellejin@chargingsoup.com</span>
                </div>
              </div>
            </div>
          </div>
          <div className='footerCon02'>
            <div className='footerConLeft'>
              <img src={require('./assets/img/logoicon.png')} alt='pic'/>
              <div className='footerCopyRight'>
                <p>爆品涩:2024-至今 AII Rights RESERVED | 上海爆品涩科技有限责任公司 ｜ <a target='_blank' rel="noreferrer" href='https://beian.miit.gov.cn/'>沪ICP备2023019866号</a></p>
                <p>营业执照：9131012MADY6M31C</p>
              </div>
              <div className='footerXie'>
                <div
                onClick={()=>{
                    navigate('/Xieyi2');
                }}
              className='footerXieText'>隐私政策</div>
                <div      onClick={()=>{
                    navigate('/Xieyi');
                }}className='footerXieText'>用户协议</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FlvPlayer;